/* app/js/src/components/common/tag/tag.component.scss */
.cursor-pointer {
  cursor: pointer;
}
div {
  position: relative;
  background-color: #f1f3f4;
  border: 1px solid #dde3e7;
  border-radius: 4px;
  margin-right: 5px;
  margin-bottom: 5px;
  -webkit-animation-delay: 0;
  -webkit-animation-duration: 0.2s;
  -webkit-animation-name: fadeInFromBottom;
  -webkit-animation-fill-mode: forwards;
  -webkit-animation-iteration-count: 1;
  -moz-animation-delay: 0;
  -moz-animation-duration: 0.2s;
  -moz-animation-name: fadeInFromBottom;
  -moz-animation-fill-mode: forwards;
  -moz-animation-iteration-count: 1;
  -o-animation-delay: 0;
  -o-animation-duration: 0.2s;
  -o-animation-name: fadeInFromBottom;
  -o-animation-fill-mode: forwards;
  -o-animation-iteration-count: 1;
  animation-delay: 0;
  animation-duration: 0.2s;
  animation-name: fadeInFromBottom;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
}
div span {
  color: #232f3a;
  text-transform: uppercase;
  font-size: 0.8em;
  padding: 6px 5px;
  padding-right: 12px;
  display: block;
}
div i {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 7px;
  height: 7px;
  cursor: pointer;
}
div i svg path {
  fill: #788a9c;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
/*# sourceMappingURL=tag.component.css.map */
